import { EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
  selector: '[appDateMask]',
  standalone: true,
})
export class DateMaskDirective {
  @Input() maskType: string;
  @Input() noFutureDate: boolean = false;

  @Output() dateMaskError = new EventEmitter<boolean>();

  private static readonly DATE_MASK_ERROR_CLASS = 'date-mask-error';

  constructor() { }

  @HostListener('input', ['$event'])
  onKeyDown(event: any) {
    const input = event.target as HTMLInputElement;
    const rawValue = input.value;
    
    if (rawValue.includes('*')) {
      // Allow wildcards but limit to max 10 characters (MM/DD/YYYY format)
      let filtered = rawValue.replace(/[^0-9*/]/g, '');
      if (filtered.length > 10) {
        filtered = filtered.slice(0, 10);
      }
      input.value = filtered;
      input.classList.remove(DateMaskDirective.DATE_MASK_ERROR_CLASS);
      input.setCustomValidity('');
      this.dateMaskError.emit(false);
      return;
    }
    
    let value = rawValue.replace(/[^0-9]/g, '');
    if (value.length > 8) value = value.slice(0, 8);
    let formatted = value;
    if (value.length > 4) {
      formatted = value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4);
    } else if (value.length > 2) {
      formatted = value.slice(0, 2) + '/' + value.slice(2);
    }
    input.value = formatted;

    if (formatted.length === 10) {
      const isValid = this.isValidDate(formatted);
      if (!isValid) {
        input.classList.add(DateMaskDirective.DATE_MASK_ERROR_CLASS);
        input.setCustomValidity('Invalid date');
        this.dateMaskError.emit(true);
      } else {
        input.classList.remove(DateMaskDirective.DATE_MASK_ERROR_CLASS);
        input.setCustomValidity('');
        this.dateMaskError.emit(false);
      }
    } else {
      input.classList.remove(DateMaskDirective.DATE_MASK_ERROR_CLASS);
      input.setCustomValidity('');
      this.dateMaskError.emit(false);
    }
  }

  private isValidDate(formatted: string): boolean {
    const [mm, dd, yyyy] = formatted.split('/').map(Number);
    if (
      isNaN(mm) || isNaN(dd) || isNaN(yyyy) ||
      mm < 1 || mm > 12 ||
      dd < 1 || dd > 31 ||
      yyyy < 1000 || yyyy > 9999
    ) {
      return false;
    }
    const dt = new Date(yyyy, mm - 1, dd);
    const isValidCalendarDate = (
      dt.getFullYear() === yyyy &&
      dt.getMonth() === mm - 1 &&
      dt.getDate() === dd
    );
    
    if (!isValidCalendarDate) {
      return false;
    }
    
    // Check for future date if noFutureDate is enabled
    if (this.noFutureDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dt > today) {
        return false;
      }
    }
    
    return true;
  }
}
